import React from 'react';
import './contactUs.css';

const ContactInfo = () => {
  return (
    <div>
    <div className="contact-info">
     <div className="contact-left-box">   
      <div>
      <h2>Contact Information</h2>
      <div className="contact-line">
      </div>
      <div className="company-info">
        <div className="blue-h2">CBH TECH INDIA PRIVATE LIMITED</div>
      </div>
      <div className="address-info">
        <p>Office No. 727, 7TH Floor , Tower T3, Golden I,<br></br> Amrapalli leisure valley Tech Zone IV,<br></br> Greater Noida West Uttar Pradesh,<br></br> 201308, INDIA</p>
      </div>
      <div className="contact-details">
        <p>Phone - +91 9115111899</p>
        {/* <p>Customer Support - 1800-891-0329</p> */}
        <p>Email - info@hotcharge.in</p>
        <p>Parent Company - CBH TECH INDIA PRIVATE LIMITED </p>
      </div>
      </div>
      <div className="social-media">
      @2024 all rights reserved
      </div>
      </div>
      <div className="links">
      <div>
        <h2 className="header-contact">Company</h2>
        <div className="contact-line-right">
      </div>
        <div className="contact-right-margin">
        <a href="#b3">How it works</a>
        </div>
        <div className="contact-right-margin">
        <a href="#b5">Specification</a>
        </div>
        <div className="contact-right-margin">
        <a href="#">Venue Partners</a>
        </div>
        <div className="contact-right-margin">
        <a href="#b6">Become a Partner</a>
        </div>
        <div className="contact-right-margin">
        <a href="#faq">FAQ's</a>
        </div>
        <div className="contact-right-margin">
        <a href="#">Terms and Conditions</a>
        </div>
        <div className="contact-right-margin">
        <a href="#">Privacy Policy</a>
        </div>
      </div>
      <div className="social-media-mob">
      @2024 all rights reserved
      </div>
      </div>
    </div>
    </div>
  );
};

export default ContactInfo;


// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.js